module.exports = __webpack_public_path__ + "img/joinUs_4.ade74bf9.png";